<div class="sp-dialog__max-width-m sp-dialog__min-width">
  <div class="sp-width__full sp-row__end">
    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div class="sp-padding__x2">
    <h3
      class="sp-color__accent"
      [innerHTML]="
        'CLUSTER.UPDATE_USURY_THRESHOLD_TITLE'
          | translate : { cluster_code: row?.cluster_code, steps_number: row?.steps_number }
      "></h3>
    <form
      [formGroup]="cluster_update_usury_threshold_form_group"
      class="sp-margin__top-x2">
      <mat-form-field
        class="sp-width__full sp-form-field sp-margin__bottom-x2"
        appearance="fill"
        color="accent">
        <mat-label>{{ 'CLUSTER.USURY_THRESHOLD_LABEL' | translate }}</mat-label>
        <input
          matInput
          type="number"
          step="0.01"
          formControlName="max_tan"
          [errorStateMatcher]="error_matcher"
          placeholder="0.00"
          required />
        <span matSuffix>%</span>
      </mat-form-field>

      <app-shared-button
        class="sp-width__full sp-margin__top"
        [button_class]="'sp-button__main'"
        [spinner_class]="'sp-spinner__main'"
        [cta]="'GENERAL.CONFIRM_CTA'"
        [is_disabled]="is_submit_running"
        [is_spinner_visible]="is_submit_running"
        (click)="onSubmitClick()"></app-shared-button>
    </form>
  </div>
</div>
